{
  "close": "Cerrar",
  "notifications": "Notificaciones"
}
